import React from 'react'
import { SearchContainer } from "../../Containers/containersBarrel"
import { Link } from 'react-router-dom'

import './RBL.css'

export class RBL extends React.Component {
    componentDidMount() {
        let footer = document.getElementById('Footer')
        footer.style.position = 'relative'
    }

    render() {
        return (
            <div className="RBLPage">
                <div className="BackgroundImageSection">
                    <div className="SearchAndTitleContainer">
                        <SearchContainer
                            className="Search"
                            location={this.props.location.pathname}
                            resetLocalStorage="true"
                        />
                    </div>
                </div>
                <div className="TextContainer container">
                    <div className="RBLTextContainer">
                        <span className="RBLTextTitle">Review of Biblical Literature</span>
                        <div className="row">
                            <p>
                                <i>Review of Biblical Literature</i> (<i>RBL</i>) is a publication of
                                SBL Press that presents reviews of books in biblical studies
                                and related fields. Published digitally on this site and in an annual print edition, <i>RBL</i> is comprehensive, international, and timely.
                                Sign in with your SBL membership to read reviews. For more information or to subscribe, see the <a href="https://www.sbl-site.org/sbl-press/browse-journals/review-of-biblical-literature/" rel="noopener noreferrer" target="_blank">SBL website</a>.
                            </p>
                        </div>
                        <div className="row">
                            <p>
                                Using the filter to the left of search results, you can limit
                                your search to books with published reviews or books for which
                                you can volunteer to review. For further instructions on searching,
                                see the <a href="/help">Help</a> page.
                            </p>
                        </div>
                        <div className="row">
                            <p>
                                For answers to commonly asked questions on the following topics, please consult
                                the <Link to="/files/RBLGuidelines.pdf" rel="noopener noreferrer" target="_blank" download><i>RBL</i> Guidelines</Link>.
                            </p>
                        </div>
                        <div className="row">
                            <ul className='rblBulletList'>
                                <li>review format and guidelines</li>
                                <li>requesting a due-date extension</li>
                                <li>submitting a finished review</li>
                                <li>volunteering to review a book</li>
                                <li>responding to an unfair review</li>
                            </ul>
                        </div>
                        <div className="row">
                            <p>
                                You may email all other questions to the <i>RBL</i> Managing Editor
                                at <a href="mailto:RBLadministrator@sbl-site.org">RBLadministrator@sbl-site.org</a>.
                            </p>
                        </div>
                        <div className="row">
                            <p>
                                Publishers interested in having their books listed on SBL Central and
                                reviewed in <i>RBL</i> should visit the <a href="/home/publishers">Publishers</a> page.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
